import { gql } from "@apollo/client";

export const UpdatePaymentProcessorByPk = gql`
  mutation UpdatePaymentProcessor(
    $id: Int!
    $set: payment_processor_config_set_input
  ) {
    update_payment_processor_config_by_pk(pk_columns: { id: $id }, _set: $set) {
      id
    }
  }
`;

export const CreatePaymentProcessor = gql`
  mutation CreatePaymentProcessor(
    $input: payment_processor_config_insert_input!
  ) {
    insert_payment_processor_config_one(object: $input) {
      id
    }
  }
`;

export const DeletePaymentProcessor = gql`
  mutation delete_payment_processor_config($id: Int!) {
    delete_payment_processor_config_by_pk(id: $id) {
      id
    }
  }
`;

export const BulkUnassignProcessor = gql`
  mutation BulkUnassignProcessor($processorId: Int!) {
    update_locations(
      where: { payment_processor_id: { _eq: $processorId } }
      _set: { payment_processor_id: null }
    ) {
      affected_rows
    }
    update_locations_order_ahead(
      where: { payment_processor_id: { _eq: $processorId } }
      _set: { payment_processor_id: null }
    ) {
      affected_rows
    }
    update_events_payments: update_events(
      where: { payment_processor_id: { _eq: $processorId } }
      _set: { payment_processor_id: null }
    ) {
      affected_rows
    }
    update_events_ticketing: update_events(
      where: { ticketing_payment_processor_id: { _eq: $processorId } }
      _set: { ticketing_payment_processor_id: null }
    ) {
      affected_rows
    }
    update_events_invoicing: update_events(
      where: { invoicing_payment_processor_id: { _eq: $processorId } }
      _set: { invoicing_payment_processor_id: null }
    ) {
      affected_rows
    }
  }
`;
